




import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class MarkdownContainer extends Vue {
  @Prop(String) content: '';

  /*
    This method will be triggered when markdown receives async content.
    The objective of it is to force images to have the right ratio as content
    received applies unexpected inline styles/attributes. This function also
    add style resets for tables.
  */
  @Watch('content')
  handleContent () {
    if (process.client) {
      const element = document.getElementsByClassName('resetAccessMarkdown');
      setTimeout(() => {
        const imgs = element[0].querySelectorAll('img');
        imgs.forEach((element) => {
          if (
            element.getAttribute('height') &&
          element.getAttribute('width')
          ) {
            element.style.height = `auto`;
            element.style.width += `${element.getAttribute('width')}px`;
          }
        });

        const tables = element[0].querySelectorAll('table');
        tables.forEach((table) => {
          const wrapper = document.createElement('div');
          wrapper.classList.add('overflow-x-auto');
          table.parentNode?.insertBefore(wrapper, table);
          wrapper.appendChild(table);
        });
      }, 500);
    }
  }
}
